module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-code-wrap"
  }, [_c('h2', [_vm._v("输入位置快捷码")]), _vm._v(" "), _c('span', {
    staticClass: "remove",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_c('ul', {
    staticClass: "security-code-container"
  }, _vm._l((_vm.number), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "field-wrap"
    }, [_c('i', {
      staticClass: "char-field"
    }, [_vm._v(_vm._s(_vm.value[index] || _vm.placeholder))])])
  }), 0)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "err"
  }, [_vm._v("请输入正确的快捷码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "input-code",
    staticStyle: {
      "ime-mode": "disabled"
    },
    attrs: {
      "id": "code",
      "name": "code",
      "type": "text",
      "maxlength": _vm.number,
      "autocorrect": "off",
      "autocomplete": "off",
      "autocapitalize": "off"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": function($event) {
        return _vm.handleInput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cef5386"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/camp-code/index.vue
// module id = 289
// module chunks = 107